export class GroupType {
    static ReportTitle = "1";
    static VoucherEntry = "2";

    value: string;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}



export class BSPL {
    static BS = 'BS';
    static PL = 'PL';

    value: string;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}


export class AccType {

    static Assets = 1;
    static Liability = 2;
    static AR = 3;
    static AP = 4;
    static Capital = 5;
    static Bank = 6;
    static Retained_Earnings = 7;
    static Expenses = 8;
    static Income = 9;
    static Exchange_Gain = 10;
    static Exchange_Loss = 11;

    value: string;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}


export class DrCr {
    static Dr = 'Dr';
    static Cr = 'Cr';

    value: string;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}

export class AllowNegBal {
    static N = 'N';
    static Y = 'Y';

    value: string;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}

export class Disable {
    static N = 'N';
    static Y = 'Y';

    value: string;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}
